export default "__VITE_ASSET__d5feb10e__"